import { getCustomDomainCluster } from "config/customDomainClusters";

const CLUSTER_SCOPED_ROUTES = new Set([
  "dashboard",
  "payments",
  "subscriptions-plans",
  "documents",
  "payment-methods",
  "action-center",
  "my-profile",
  "notification",
  "make-payment",
  "quick-checkout",
  "support-help",
  "otp-verification",
  "otp-send",
  "login",
  "login-via-cred",
  "sign-up",
  "sign-up-password",
  "sign-up-email-attached",
  "forgot-password",
  "reset-password",
  "request-access",
  "access-request-send-successfully",
  "sign-up-otp-verification",
  "forgot-otp-verification",
  "set-password",
]);

type DecodeClusterSlug = (clusterSlug: string) => string | null;

type CustomDomainRedirectInput = {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
  decodeClusterSlug: DecodeClusterSlug;
};

export type CustomDomainRedirect = {
  pathname: string;
  search: string;
  hash: string;
};

/**
 * Returns an internal redirect when a mapped custom domain is missing its
 * cluster segment. Public action/payment URLs are deliberately left alone.
 */
export const getCustomDomainRedirect = ({
  hostname,
  pathname,
  search,
  hash,
  decodeClusterSlug,
}: CustomDomainRedirectInput): CustomDomainRedirect | null => {
  const domainCluster = getCustomDomainCluster(hostname);

  if (!domainCluster || pathname === "/invalid") {
    return null;
  }

  const segments = pathname.split("/").filter(Boolean);
  const firstSegment = segments[0];

  if (firstSegment?.startsWith("ci_")) {
    if (firstSegment === domainCluster.clusterSlug) {
      return null;
    }

    const pathClusterId = decodeClusterSlug(firstSegment);
    return pathClusterId === domainCluster.clusterId
      ? null
      : { pathname: "/invalid", search: "", hash: "" };
  }

  const needsClusterPrefix =
    !firstSegment ||
    (segments.length === 1 && CLUSTER_SCOPED_ROUTES.has(firstSegment));

  if (!needsClusterPrefix) {
    return null;
  }

  const suffix = firstSegment ? pathname : "";

  return {
    pathname: `/${domainCluster.clusterSlug}${suffix}`,
    search,
    hash,
  };
};
